<template>
  <el-row id="limits" style="height: 100%;overflow:scroll;overflow-y:hidden;overflow-x:hidden ">
    <!--添加角色-->
    <el-dialog title="" :visible.sync="dialogFormVisible" style="border-radius: 30px">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">新增角色</span>
        <span>
          <el-button @click="submitForm" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="resetForm" size="small">取 消</el-button>
        </span>
      </div>
      <el-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm" :hide-required-asterisk="roleFalse">
        <el-form-item label="名称" label-width="120px" prop="role_name">
          <el-input v-model="form.role_name" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>
        <!--                <el-form-item label="类型" label-width="120px">-->
        <!--                    <el-input v-model="form.role_code"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="说明" label-width="120px">
          <el-input type="textarea" v-model="form.comments" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--编辑角色-->
    <el-dialog title="" :visible.sync="dialogFormVisible2">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">编辑角色</span>
        <span>
          <el-button @click="updateRole" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="dialogFormVisible2 = false" size="small">取 消</el-button>
        </span>
      </div>
      <el-form :model="upForm">
        <el-form-item label="名称" label-width="120px">
          <el-input v-model="upForm.role_name" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>
        <!--                <el-form-item label="类型" label-width="120px">-->
        <!--                    <el-input v-model="upForm.role_code"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="说明" label-width="120px">
          <el-input type="textarea" v-model="upForm.comments" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--添加用户-->
    <el-dialog title="" :visible.sync="dialogFormVisible3" width="70%" height="70%">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加用户</span>
        <span>
          <el-button @click="addUserRole" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="cancelDialog()" size="small">取 消</el-button>
        </span>
      </div>
      <el-row style="height: auto">
        <el-col :span="8" style="padding-right: 10px">
          <el-scrollbar style="height: 680px;overflow: hidden; border: 1px solid #D4D4D4">
            <el-tree
              :data="data2"
              node-key="id"
              ref="tree2"
              highlight-current
              :props="defaultProps2"
              @node-click="handleNodeClick2"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="display: inline-block;width: 17px;height: 18px;margin: 0 20px 0 0">
                  <img v-bind:src="icon[node.level < 4 ? node.level - 1 : 2]" alt=" " />
                </span>
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </el-col>

        <el-col :span="16">
          <el-table :data="tableData" stripe style="width: 100%;" border @row-click="rowClick">
            <!--                :row-class-name="tableRowClassName"-->

            <el-table-column label="选择" width="50" fixed="left">
              <template slot-scope="scope">
                <img :src="radio_checked" v-if="radio == scope.row.rowIndex" />
                <img :src="radio_unchecked" v-else="radio !== scope.row.rowIndex" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="80" sortable></el-table-column>
            <el-table-column prop="sex" label="性别" width="80" sortable></el-table-column>
            <el-table-column prop="duty" label="职务" width="80" sortable></el-table-column>
            <el-table-column prop="phone" label="手机" sortable></el-table-column>
            <el-table-column prop="zhuGuan" label="部门主管" width="110" sortable></el-table-column>
            <el-table-column prop="status" label="状态" width="80" sortable></el-table-column>
          </el-table>
          <pagination style="margin-top: 20px" :page="page" @changePage="changePageClick"></pagination>
          <div class="message" v-if="messageDis">
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">姓名</el-col>
              <el-col :span="6" style="color: #409EFF">{{ userInfo.name }}</el-col>
              <el-col :span="3" style="float: right;"> </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">性别</el-col>
              <el-col :span="6" style="color: #4A4A4A;">{{ userInfo.sex }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">生日</el-col>
              <el-col :span="6" style="color: #4A4A4A;">
                <span>{{ userInfo.birthday }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">手机</el-col>
              <el-col :span="6" style="color: #4A4A4A;">{{ userInfo.phone }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">职务</el-col>
              <el-col :span="6" style="color: #4A4A4A;">{{ userInfo.duty }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">角色</el-col>
              <el-col :span="20">
                <el-tag
                  type="danger"
                  effect="dark"
                  size="mini"
                  v-for="(item, index) in userInfo.role"
                  :key="index"
                  v-if="item.role_name"
                  style="margin-right:5px;background: #FF9901;border: none;color: white;"
                >
                  {{ item.role_name }}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">主管</el-col>
              <el-col :span="6" style="color: #7ED321;">{{ userInfo.zhuGuan }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" style="font-weight: bold;color: #000;">状态</el-col>
              <el-col :span="6" style="color: #7ED321;">{{ userInfo.status }}</el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--添加功能权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible4">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加功能权限</span>
        <span>
          <el-button @click="addAction" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible4 = false
              action_id = ''
            "
            size="small"
            >取 消
          </el-button>
        </span>
      </div>
      <ul class="ul" style="height: 500px;overflow: auto;padding: 10px 30px">
        <li
          v-for="(item, index) in options"
          :key="index"
          style="border: none;"
          @click="changeRadioActions(item, index)"
        >
          <div
            style="width: 100%;height: auto;border-bottom: 1px solid #F6F6F6;
                            padding:20px;display: flex;box-sizing: border-box"
          >
            <div style="width: 40px;height: 60px;display: flex;align-items:center">
              <img :src="require('../../../assets/images/limits.png')" alt="" width="30" height="38" />
            </div>
            <div style="width: 100%;height: 60px;margin-top: -6px;padding-left: 30px">
              <el-row>
                <el-col :span="18" style="height: auto;margin-bottom: 0">
                  <el-row style="font-size:16px;color:#4A90E2;padding-top:5px;margin-bottom: 0">
                    {{ item.action_name }}</el-row
                  >
                  <el-row style="height: auto;color: #b0b5b9;margin-top: 10px">
                    {{ item.comments }}
                  </el-row>
                </el-col>
                <el-col :span="6" style="text-align: right;line-height: 60px">
                  <img :src="item.check" alt="" />
                </el-col>
              </el-row>
            </div>
          </div>
        </li>
      </ul>
      <!--            <el-form :model="addLimitForm">-->
      <!--                <el-form-item label="功能权限" label-width="120px">-->
      <!--                    <el-select v-model="action_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options"-->
      <!--                                :key="item.action_id"-->
      <!--                                :label="item.action_name"-->
      <!--                                :value="item.action_id"-->
      <!--                                :disabled="(actionsArr.indexOf(item.action_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>
    <!--添加报表权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible5">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加报表权限</span>
        <span>
          <el-button @click="addReport" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible5 = false
              report_id = ''
            "
            size="small"
            >取 消
          </el-button>
        </span>
      </div>
      <ul class="ul" style="height: 500px;overflow: auto;padding: 10px 30px">
        <li
          v-for="(item, index) in options2"
          :key="index"
          style="border: none;"
          @click="changeRadioReport(item, index)"
        >
          <div
            style="width: 100%;height: auto;border-bottom: 1px solid #F6F6F6;
                            padding:20px;display: flex;box-sizing: border-box"
          >
            <div style="width: 40px;height: 60px;display: flex;align-items:center">
              <img :src="require('../../../assets/images/limits.png')" alt="" width="30" height="38" />
            </div>
            <div style="width: 100%;height: 60px;margin-top: -6px;padding-left: 30px">
              <el-row>
                <el-col :span="18" style="height: auto;margin-bottom: 0">
                  <el-row style="font-size:16px;color:#4A90E2;padding-top:5px;margin-bottom: 0">
                    {{ item.report_name }}</el-row
                  >
                  <el-row style="height: auto;color: #b0b5b9">
                    {{ item.comments }}
                    <!--                                        {{item.test}}-->
                  </el-row>
                </el-col>
                <el-col :span="6" style="text-align: right;line-height: 60px">
                  <img :src="item.check" alt="" />
                </el-col>
              </el-row>
            </div>
          </div>
        </li>
      </ul>
      <!--            <el-form :model="addstatementForm">-->
      <!--                <el-form-item label="报表权限" label-width="120px">-->
      <!--                    <el-select v-model="report_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options2"-->
      <!--                                :key="item.report_id"-->
      <!--                                :label="item.report_name"-->
      <!--                                :value="item.report_id"-->
      <!--                                :disabled="(reportsArr.indexOf(item.report_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>

    <!--添加页面权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible6" id="pageDialog">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加页面权限</span>
        <span>
          <el-button @click="addPages" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible6 = false
              menu_id = ''
            "
            size="small"
            >取 消</el-button
          >
        </span>
      </div>
      <!--            <ul class="ul" style="height: 500px;overflow: auto;padding: 10px 30px">-->
      <!--                <li v-for="item,index in options3" :key="index" style="border: none;" @click="changeRadio(item,index)">-->
      <!--                    <div-->
      <!--                            style="width: 100%;height: auto;border-bottom: 1px solid #F6F6F6;-->
      <!--                            padding:20px;display: flex;box-sizing: border-box">-->
      <!--                        <div style="width: 40px;height: 60px;display: flex;align-items:center">-->
      <!--                            <img :src="require('../../../assets/images/limits.png')" alt="" width="30" height="38">-->
      <!--                        </div>-->
      <!--                        <div style="width: 100%;height: 60px;margin-top: -6px;padding-left: 30px">-->
      <!--                            <el-row>-->
      <!--                            <el-col :span="18" style="height: auto;margin-bottom: 0">-->
      <!--                                <el-row  style="font-size:16px;color:#4A90E2;padding-top:5px;margin-bottom: 0">-->
      <!--                                    {{item.menu_name}}</el-row>-->
      <!--                                <el-row style="height: auto;color: #b0b5b9">-->
      <!--                                    {{item.comments}}-->
      <!--                                </el-row>-->
      <!--                            </el-col>-->
      <!--                            <el-col :span="6" style="text-align: right;line-height: 60px">-->
      <!--                                <img :src="item.check" alt="">-->
      <!--                            </el-col>-->
      <!--                            </el-row>-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                </li>-->
      <!--            </ul>-->
      <div style="overflow: hidden;overflow-y: auto;border:2px solid #f6f6f6;height: 500px;">
        <!--                <el-checkbox v-model="checkAll" @change="handleCheckAllChange('android')" style="margin-left: 24px;margin-top:12px;margin-bottom: 10px;">全选</el-checkbox>-->
        <el-tree ref="treePage" style="" :data="optionsPage" show-checkbox node-key="key_id" :props="defaultPageProps">
        </el-tree>
      </div>

      <!--            <el-form :model="addstatementForm">-->
      <!--                <el-form-item label="页面权限" label-width="120px">-->
      <!--                    <el-select v-model="menu_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options3"-->
      <!--                                :key="item.menu_id"-->
      <!--                                :label="item.menu_name"-->
      <!--                                :value="item.menu_id"-->
      <!--                                :disabled="(pagesArr.indexOf(item.menu_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>

    <!--添加android页面权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible7" class="pageDialog">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加Android权限</span>
        <span>
          <el-button @click="addandroidPages" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible7 = false
              menu_id = ''
            "
            size="small"
            >取 消</el-button
          >
        </span>
      </div>
      <div style="overflow: hidden;overflow-y: auto;border:2px solid #f6f6f6;height: 500px;">
        <el-checkbox
          v-model="checkAll"
          @change="handleCheckAllChange('android')"
          style="margin-left: 24px;margin-top:12px;margin-bottom: 10px;"
          >全选</el-checkbox
        >
        <el-tree
          ref="androidtreePage"
          style=""
          :data="optionsandroidPage"
          show-checkbox
          node-key="key_id"
          :props="defaultandroidPageProps"
        >
        </el-tree>
      </div>

      <!--            <el-form :model="addstatementForm">-->
      <!--                <el-form-item label="页面权限" label-width="120px">-->
      <!--                    <el-select v-model="menu_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options3"-->
      <!--                                :key="item.menu_id"-->
      <!--                                :label="item.menu_name"-->
      <!--                                :value="item.menu_id"-->
      <!--                                :disabled="(pagesArr.indexOf(item.menu_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>

    <!--添加h5页面权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible9" class="pageDialog">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加H5权限</span>
        <span>
          <el-button @click="addh5Pages" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible9 = false
              menu_id = ''
            "
            size="small"
            >取 消</el-button
          >
        </span>
      </div>
      <div style="overflow: hidden;overflow-y: auto;border:2px solid #f6f6f6;height: 500px;">
        <el-checkbox
          v-model="checkAll"
          @change="handleCheckAllChange('h5')"
          style="margin-left: 24px;margin-top:12px;margin-bottom: 10px;"
          >全选</el-checkbox
        >
        <el-tree
          ref="h5treePage"
          style=""
          :data="optionsh5Page"
          show-checkbox
          node-key="key_id"
          :props="defaulth5PageProps"
        >
        </el-tree>
      </div>

      <!--            <el-form :model="addstatementForm">-->
      <!--                <el-form-item label="页面权限" label-width="120px">-->
      <!--                    <el-select v-model="menu_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options3"-->
      <!--                                :key="item.menu_id"-->
      <!--                                :label="item.menu_name"-->
      <!--                                :value="item.menu_id"-->
      <!--                                :disabled="(pagesArr.indexOf(item.menu_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>

    <!--添加ios页面权限-->
    <el-dialog title="" :visible.sync="dialogFormVisible8" class="pageDialog">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加iOS权限</span>
        <span>
          <el-button @click="addiosPages" type="primary" size="small">保 存</el-button>
          <el-button
            type="danger"
            @click="
              dialogFormVisible8 = false
              menu_id = ''
            "
            size="small"
            >取 消</el-button
          >
        </span>
      </div>
      <div style="overflow: hidden;overflow-y: auto;border:2px solid #f6f6f6;height: 500px;">
        <el-checkbox
          v-model="checkAll"
          @change="handleCheckAllChange('ios')"
          style="margin-left: 24px;margin-top:12px;margin-bottom: 10px;"
          >全选</el-checkbox
        >
        <el-tree
          ref="iostreePage"
          style=""
          :data="optionsiosPage"
          show-checkbox
          node-key="key_id"
          :props="defaultiosPageProps"
        >
        </el-tree>
      </div>

      <!--            <el-form :model="addstatementForm">-->
      <!--                <el-form-item label="页面权限" label-width="120px">-->
      <!--                    <el-select v-model="menu_id" placeholder="请选择" style="width: 100%;">-->
      <!--                        <el-option-->
      <!--                                v-for="item in options3"-->
      <!--                                :key="item.menu_id"-->
      <!--                                :label="item.menu_name"-->
      <!--                                :value="item.menu_id"-->
      <!--                                :disabled="(pagesArr.indexOf(item.menu_id)!== -1) ? true : false">-->
      <!--                        </el-option>-->
      <!--                    </el-select>-->
      <!--                </el-form-item>-->
      <!--            </el-form>-->
    </el-dialog>

    <el-col :span="8" style="height:100%;background: white;width: 400px">
      <el-row type="flex" justify="center" style="height: 30px;">
        <el-col :span="24">
          <el-col :span="24" style="text-align: end;">
            <span style="font-size: 19px;float: left;line-height: 30px;font-weight: bold">角色列表</span>
            <el-button type="success" style="background: #4EC880" icon="el-icon-plus" size="small" @click="open3"
              >新增角色
            </el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="height: calc(100% - 43px);">
        <el-col :span="24" style="height: auto;border: 1px solid #eee;">
          <div style="padding: 10px;">
            <el-input class="sWei" :placeholder="iconPlace" v-model="filterText"> </el-input>
          </div>
          <!--:class="$style.scrollbar"-->
          <el-scrollbar id="el-scollbar" style="height:calc(100% - 59px);">
            <el-tree
              class="filter-tree"
              :data="data"
              @node-click="handleNodeClick"
              :props="defaultProps"
              node-key="role_id"
              :highlight-current="true"
              :filter-node-method="filterNode"
              :default-expanded-keys="[1000, 2000]"
              ref="tree"
            >
            </el-tree>
          </el-scrollbar>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="16" class="StoCen" style="height: auto;overflow: auto;">
      <el-row style="height: 20px;margin-top: 4px" type="flex" align="middle">
        <el-col :span="3" style="font-size: 17px;font-weight: bold">角色</el-col>
        <el-col :span="8" style="color: #409EFF;font-size: 17px;font-weight: bold">{{ schTitle1 }}</el-col>
        <el-col :span="3" :push="10">
          <el-button
            v-if="updataActive"
            type="text"
            @click="open4"
            :style="{ color: updataActive ? '#FF9901' : '#eee', float: 'right' }"
            style="font-size: 17px;font-weight: bold"
            id="el-button"
            >编辑
          </el-button>
        </el-col>
      </el-row>
      <el-row class="xux"></el-row>
      <el-row type="flex" align="middle">
        <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">用户数：{{ user.length }}个</el-col>
        <el-col :span="8" style="text-align: end;">
          <el-button
            type="success"
            :disabled="addUserDis"
            style="background: #4EC880;border: none"
            icon="el-icon-plus"
            size="small"
            @click="addListOpen"
            >添加用户
          </el-button>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-bottom: 20px">
        <el-tab-pane label="用户" name="user">
          <el-row style="height: auto;display: flex;flex-wrap:wrap;">
            <myuser
              v-for="(item, index) in user"
              :key="index"
              :userName="item.last_name"
              :sex="item.gender"
              :phone="item.phone"
              v-on:pullClick="open(index)"
              style="margin:20px 25px 0 0"
            ></myuser>
          </el-row>
          <!-- <el-row type="flex" align="middle">
                        <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
                            权限数：{{limits.length}}个</el-col>
                        <el-col :span="8" style="text-align: end;">
                            <el-button v-if="updataActive" type="success" icon="el-icon-plus"
                                style="background: #4EC880;border:none" size="small" @click="limitsOpen"
                                :disabled="!updataActive">添加权限
                            </el-button>
                        </el-col>
                    </el-row> -->
          <!-- <limits v-for="(item,index) in limits" :key="index" :limitState="item.comments"
                        :active="updataActive" :limitName="item.action_name"
                        v-on:pullClick="updataActive?limitpen(index):''" style="margin-top:20px "></limits> -->
        </el-tab-pane>
        <el-tab-pane label="功能权限" name="system">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
              权限数：{{ limits.length }}个</el-col
            >
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                type="success"
                icon="el-icon-plus"
                style="background: #4EC880;border:none"
                size="small"
                @click="limitsOpen"
                :disabled="!updataActive"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits
            v-for="(item, index) in limits"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.action_name"
            v-on:pullClick="updataActive ? limitpen(index) : ''"
            style="margin-top:20px "
          ></limits>
        </el-tab-pane>
        <el-tab-pane label="报表权限" name="statement">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
              权限数：{{ statement.length }}个</el-col
            >
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                style="background: #4EC880;border:none"
                type="success"
                icon="el-icon-plus"
                size="small"
                @click="statementOpen"
                :disabled="!updataActive"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits
            v-for="(item, index) in statement"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.report_name"
            v-on:pullClick="updataActive ? deleteStatementOpen(index) : ''"
            style="margin-top:20px "
          ></limits>
        </el-tab-pane>

        <el-tab-pane label="页面权限" name="pages">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px "
              >权限数：{{ pages.length }}个
            </el-col>
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                type="success"
                style="background: #4EC880;border:none"
                icon="el-icon-plus"
                size="small"
                @click="pagesOpen"
                :disabled="!updataActive"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits
            v-for="(item, index) in pages"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.menu_name"
            v-on:pullClick="updataActive ? deletePagesOpen(index) : ''"
            style="margin-top:20px "
          ></limits>
        </el-tab-pane>

        <el-tab-pane label="App权限(iOS)" name="iospages">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
              权限数：{{ iospages.length }}个</el-col
            >
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                type="success"
                style="background: #4EC880;border:none"
                icon="el-icon-plus"
                size="small"
                @click="iospagesOpen"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits2
            v-for="(item, index) in iospages"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.menu_name"
            v-on:pullClick="updataActive ? deleteIosPagesOpen(index) : ''"
            style="margin-top:20px "
          ></limits2>
        </el-tab-pane>
        <el-tab-pane label="App权限(Android)" name="androidpages">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
              权限数：{{ androidpages.length }}个</el-col
            >
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                type="success"
                style="background: #4EC880;border:none"
                icon="el-icon-plus"
                size="small"
                @click="androidpagesOpen"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits2
            v-for="(item, index) in androidpages"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.menu_name"
            v-on:pullClick="updataActive ? deleteAndroidPagesOpen(index) : ''"
            style="margin-top:20px "
          >
          </limits2>
        </el-tab-pane>

        <el-tab-pane label="App权限(H5)" name="h5pages">
          <el-row type="flex" align="middle">
            <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">
              权限数：{{ h5pages.length }}个</el-col
            >
            <el-col :span="8" style="text-align: end;">
              <el-button
                v-if="updataActive"
                type="success"
                style="background: #4EC880;border:none"
                icon="el-icon-plus"
                size="small"
                @click="h5pagesOpen"
                >添加权限
              </el-button>
            </el-col>
          </el-row>
          <limits2
            v-for="(item, index) in h5pages"
            :key="index"
            :limitState="item.comments"
            :active="updataActive"
            :limitName="item.menu_name"
            v-on:pullClick="updataActive ? deleteH5PagesOpen(index) : ''"
            style="margin-top:20px "
          ></limits2>
        </el-tab-pane>
      </el-tabs>

      <!-- <el-row style="height: auto;display: flex;flex-wrap:wrap;">
        <myuser
          v-for="(item, index) in user"
          :key="index"
          :userName="item.last_name"
          :sex="item.gender"
          :phone="item.phone"
          v-on:pullClick="open(index)"
          style="margin:20px 25px 0 0"
        ></myuser>
      </el-row> -->
    </el-col>
  </el-row>
</template>

<script>
import Vue from 'vue'
import http from '../../../APIService/http'
import User from './user'
import LimitsList from './limitsList'
import LimitsList2 from './limitsList2'
import pagination from '../../../components/pagination'
import radio_checked from '../../../assets/images/radio_checked.png'
import radio_unchecked from '../../../assets/images/radio_unchecked.png'
import { MessageBox, Message } from 'element-ui'
import check from '../../../assets/images/check.png'
import checkSuccess from '../../../assets/images/checkSuccess.png'
let number = 1
export default {
  name: 'Main',
  components: {
    myuser: User,
    limits: LimitsList,
    limits2: LimitsList2,
    pagination,
  },
  data() {
    return {
      checkImg: check,
      messageDis: '',
      checkListPage: [],
      checkListPageDanger: [],
      checkListActions: [],
      checkListActionsDanger: [],
      checkListReport: [],
      checkListReportDanger: [],
      userInfo: {},
      addUserDis: true,
      iconPlace: `请输入角色名称进行快速检索`,
      roleFalse: true,
      icon: [
        require('../../../assets/images/icon-t.png'),
        require('../../../assets/images/icon-f.png'),
        require('../../../assets/images/icon-g.png'),
      ],
      activeName: 'user',
      user: [
        /*{
                    userName:'用户1',
                    sex:'女',
                    phone:'134555555'
                },*/
      ],
      actionsArr: [],
      reportsArr: [],
      pagesArr: [],
      androidpagesArr: [],
      iospagesArr: [],
      h5pagesArr: [],
      limits: [
        /*{
                    limitName:'权限1',
                    limitState:'割发代首割发代首割发代首割',
                },*/
      ],
      statement: [
        /*{
                    limitName:'权限1',
                    limitState:'割发代首割发代首割发代首割发代首规范割发代首',
                },*/
      ],
      pages: [
        /*{
                    limitName:'权限1',
                    limitState:'割发代首割发代首割发代首割发代首规范割发代首',
                },*/
      ],
      androidpages: [],
      iospages: [],
      h5pages: [],
      updataActive: false,
      form: {
        role_name: '',
        role_code: '',
        comments: '',
      },
      rules: {
        role_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      upForm: {
        // role_name: '',
        // role_code: '',
        // comments: ''
      },
      addListForm: {
        key: '',
        type: '',
        status: '',
      },
      addLimitForm: {
        key: '',
        type: '',
        status: '',
      },
      addstatementForm: {
        key: '',
        type: '',
        status: '',
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      dialogFormVisible7: false,
      dialogFormVisible8: false,
      dialogFormVisible9: false,
      folderId: null,
      folderName: null,
      num: {
        sum: 0,
      },
      clickData: {},
      role_id: '',
      action_id: '',
      report_id: '',
      menu_id: '',
      options: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      optionsPage: [],
      optionsandroidPage: [],
      optionsiosPage: [],
      optionsh5Page: [],
      checkAll: false,
      expandedKeys: [],
      androidexpandedKeys: [],
      iosexpandedKeys: [],
      h5expandedKeys: [],
      myactive1: false,
      myactive2: false,
      schTitle1: '',
      //保存tree key值
      treeKey: '',
      filterText: '',
      data2: [],
      data: [
        { label: '系统内置', children: [] },
        { label: '自定义', children: [] },
      ],
      defaultProps: {
        label: 'role_name',
      },
      defaultProps2: {
        children: 'children',
        label: 'label',
      },
      defaultPageProps: {
        label: 'menu_name',
      },
      defaultandroidPageProps: {
        label: 'menu_name',
      },
      defaultiosPageProps: {
        label: 'menu_name',
      },
      defaulth5PageProps: {
        label: 'menu_name',
      },
      tableData: [],
      radio_checked: radio_checked,
      radio_unchecked: radio_unchecked,
      page: {
        current: 1,
        size: 5,
        total: 0,
      },
      radio: 0,
      user_id: '',
      ou_id: '',
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  created() {
    this.getRoleList()
    this.getActions()
    this.getReports()
    this.getPages()
    this.getandroidPages()
    this.getiosPages()
    this.geth5Pages()
    this.getOU()
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.role_name.indexOf(value) !== -1
    },
    //获取部门列表
    async getOU() {
      // const loading = this.$loading({
      //     lock: true,
      //     text: '拼命加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }

        await http.post('/wapi/v1/getOuList', data).then((res) => {
          // loading.close()
          if (res.success) {
            setTimeout(() => {
              this.$refs.tree.setCurrentKey(this.treeKey)
            }, 100)
            this.data2 = res.data
          }
        })
      } catch (err) {
        // loading.close()
        Message.error('获取失败')
      }
    },
    //删除用户页面权限弹框
    deleteandroidPagesOpen(key) {
      MessageBox.confirm('移除该页面权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteandroidPages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    deleteiosPagesOpen(key) {
      MessageBox.confirm('移除该页面权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteiosPages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    deleteh5PagesOpen(key) {
      MessageBox.confirm('移除该页面权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteh5Pages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //添加android页面权限弹框
    androidpagesOpen() {
      this.dialogFormVisible7 = true
      this.checkAll = false
      if (this.androidexpandedKeys.length == this.optionsandroidPage.length) {
        this.checkAll = true
      }
      this.$nextTick(() => {
        this.$refs.androidtreePage.setCheckedNodes(this.androidexpandedKeys)
      })
      this.options4.forEach((item) => {
        if (this.androidpagesArr.indexOf(item.menu_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },
    //添加ios页面权限弹框
    iospagesOpen() {
      this.dialogFormVisible8 = true
      this.checkAll = false
      if (this.iosexpandedKeys.length == this.optionsiosPage.length) {
        this.checkAll = true
      }
      console.log(this.iosexpandedKeys)

      this.$nextTick(() => {
        this.$refs.iostreePage.setCheckedNodes(this.iosexpandedKeys)
      })
      this.options5.forEach((item) => {
        if (this.iospagesArr.indexOf(item.menu_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },
    //添加h5页面权限弹框
    h5pagesOpen() {
      this.dialogFormVisible9 = true
      this.checkAll = false
      if (this.h5expandedKeys.length == this.optionsh5Page.length) {
        this.checkAll = true
      }
      console.log(this.h5expandedKeys)

      this.$nextTick(() => {
        this.$refs.h5treePage.setCheckedNodes(this.h5expandedKeys)
      })
      this.options6.forEach((item) => {
        if (this.h5pagesArr.indexOf(item.menu_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },

    //权限导航
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    //删除用户弹框
    open(key) {
      MessageBox.confirm('移除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteUserRole(key)
          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //删除用户功能权限弹框
    limitpen(key) {
      MessageBox.confirm('移除该功能权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteAction(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //删除用户报表权限弹框
    deleteStatementOpen(key) {
      MessageBox.confirm('移除该报表权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteReport(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },

    //删除用户页面权限弹框
    deletePagesOpen(key) {
      MessageBox.confirm('移除该页面权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deletePages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //删除用户页面权限弹框
    deleteAndroidPagesOpen(key) {
      MessageBox.confirm('移除该Android权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteandroidPages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //删除用户页面权限弹框
    deleteIosPagesOpen(key) {
      MessageBox.confirm('移除该IOS权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteiosPages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //删除用户页面权限弹框
    deleteH5PagesOpen(key) {
      MessageBox.confirm('移除该H5权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteh5Pages(key)

          Message({
            type: 'success',
            message: '移除成功!',
          })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    //获取角色目录
    async getRoleList() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }

        // console.log(this.data)
        await http.post('/wapi/v1/getRoleList', data).then((res) => {
          loading.close()
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(this.treeKey)
          }, 100)
          if (res.success) {
            this.data = [
              { role_id: 1000, label: '系统内置', children: [], role_name: '系统内置' },
              { label: '自定义', children: [], role_name: '自定义', role_id: 2000 },
            ]
            //
            // console.log(res.data)
            // this.data = res.data
            //
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].builtin === 'T') {
                this.data[0].children.push(res.data[i])
              } else {
                this.data[1].children.push(res.data[i])
              }
            }
            if (this.data[1].children.length == 0) {
              this.data.splice(1, 1)
            }
            // console.log(this.data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取所有功能权限
    async getActions() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        this.data = []
        await http.post('/wapi/v1/getActions', data).then((res) => {
          loading.close()
          if (res.success) {
            this.options = res.data
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取所有报表权限
    async getReports() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        this.data = []
        await http.post('/wapi/v1/getReports', data).then((res) => {
          loading.close()
          if (res.success) {
            console.log(res)
            this.options2 = res.data
            console.log(this.options2)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取所有页面权限
    async getPages() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        // this.data = []
        await http.post('/wapi/v1/getPages', data).then((res) => {
          loading.close()
          if (res.success) {
            this.options3 = res.data
            let array = res.data
            let arrF = []
            let arrS = []
            array.forEach((item, index) => {
              item.children = []
              if (!item.parent_menu) {
                arrF.push(item)
              } else {
                arrS.push(item)
              }
            })
            for (let i = 0; i < arrS.length; i++) {
              for (let j = 0; j < arrF.length; j++) {
                if (arrS[i].parent_menu === arrF[j].menu_id) {
                  arrF[j].children.push(arrS[i])
                  break
                }
              }
            }
            this.optionsPage = arrF
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.addRole()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
      this.dialogFormVisible = false
    },

    //新增角色
    async addRole() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = this.form
        data.tenant_id = user.tenant_id

        await http.post('/wapi/v1/addRole', data).then((res) => {
          loading.close()
          if (res.success) {
            this.dialogFormVisible = false
            for (let key in this.form) {
              this.form[key] = ''
            }
            this.data[1].children.unshift(res.data[0])
            Message({
              type: 'success',
              message: '保存成功',
            })
            this.getRoleList()
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //编辑角色
    async updateRole() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let data = { ...this.upForm, ...this.clickData }

        await http.post('/wapi/v1/updateRole', data).then((res) => {
          loading.close()
          if (res.success) {
            this.schTitle1 = res.data[0].role_name
            this.dialogFormVisible2 = false
            // for (let key in this.upForm) {
            //     this.upForm[key] = ''
            // }
            setTimeout(() => {
              this.$refs.tree.setCurrentKey(this.treeKey)
            }, 100)
            this.getRoleList()
            Message({
              type: 'success',
              message: '保存成功',
            })
            this.tableData = []
          } else {
            Message.error('保存失败')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取用户列表
    async getUsersByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        this.user = []
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getUsersByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.user = []
            this.user = res.data
            this.user.forEach((item) => {
              if (item.gender === 'M') {
                item.gender = '男'
              } else if (item.gender === 'F') {
                item.gender = '女'
              } else {
                item.gender = item.gender
              }
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //添加用户列表
    async addUserRole() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: this.upForm.role_id,
          user_id: this.user_id,
        }

        await http.post('/wapi/v1/addUserRole', data).then((res) => {
          loading.close()
          if (res.success) {
            this.userInfo = {}
            this.tableData = []
            this.dialogFormVisible3 = false
            this.radio = 0
            this.user_id = ''
            this.getUsersByRoleId(this.upForm)
            ;(this.page = {
              current: 1,
              size: 5,
              total: 0,
            }),
              this.getOU()
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //移除用户列表
    async deleteUserRole(key) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: this.upForm.role_id,
          user_id: this.user[key].user_id,
        }

        await http.post('/wapi/v1/deleteUserRole', data).then((res) => {
          loading.close()
          if (res.success) {
            this.getUsersByRoleId(this.upForm)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取功能权限列表
    async getActionsByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getActionsByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.limits = []
            this.limits = res.data
            this.actionsArr = []
            res.data.forEach((item) => {
              this.actionsArr.push(item.action_id)
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取报表权限列表
    async getReportsByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getReportsByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.statement = []
            this.statement = res.data
            this.reportsArr = []
            res.data.forEach((item) => {
              this.reportsArr.push(item.report_id)
            })
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取页面权限列表
    async getPagesByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getPagesByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.pages = []
            this.pages = res.data
            this.pages.sort(function(a, b) {
              return a.sort - b.sort
            })
            this.pagesArr = []
            res.data.forEach((item) => {
              this.pagesArr.push(item.menu_id)
            })

            let array = []
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < res.data.length; j++) {
                if (res.data[j].parent_menu === res.data[i].menu_id) {
                  res.data[i].check = true
                }
              }
            }
            for (let k = 0; k < res.data.length; k++) {
              if (res.data[k].check != true) {
                let obj = res.data[k]
                array.push(obj)
              }
            }
            this.expandedKeys = array
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //添加功能权限
    async addAction() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.options.forEach((item) => {
        if (item.check === checkSuccess) {
          this.checkListActions.push(item.action_id)
        } else {
          this.checkListActionsDanger.push(item.action_id)
        }
      })
      this.deleteAction()
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          action_id: this.checkListActions,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addAction', data).then((res) => {
          debugger
          if (res.success) {
            this.dialogFormVisible4 = false
            loading.close()
            if (res.success) {
              this.action_id = ''
              this.checkListActions = []
              this.getActionsByRoleId(data)
            }
          } else {
            Message.error('保存失败!')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //删除功能权限
    async deleteAction(key) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          action_id: key != undefined ? this.limits[key].action_id : this.checkListActionsDanger,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/deleteAction', data).then((res) => {
          loading.close()
          if (res.success) {
            this.dialogFormVisible4 = false
            this.limits.splice(key, 1)
            this.action_id = ''
            this.checkListActionsDanger = []
            this.getActionsByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //添加报表权限
    addReport: async function() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.options2.forEach((item) => {
        if (item.check === checkSuccess) {
          this.checkListReport.push(item.report_id)
        } else {
          this.checkListReportDanger.push(item.report_id)
        }
      })
      this.deleteReport()
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          report_id: this.checkListReport,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addReport', data).then((res) => {
          this.dialogFormVisible5 = false
          loading.close()
          if (res.success) {
            this.report_id = ''
            this.checkListReport = []
            this.getReportsByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取所有页面权限
    async getandroidPages() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        // this.data = []
        console.log(data)
        await http.post('/wapi/v1/getandroidPages', data).then((res) => {
          loading.close()
          if (res.success) {
            console.log(res, 11)
            this.options4 = res.data
            let array = res.data
            let arrF = []
            let arrS = []
            array.forEach((item, index) => {
              item.children = []
              if (!item.parent_menu) {
                arrF.push(item)
              } else {
                arrS.push(item)
              }
            })
            for (let i = 0; i < arrS.length; i++) {
              for (let j = 0; j < arrF.length; j++) {
                if (arrS[i].parent_menu === arrF[j].menu_id) {
                  arrF[j].children.push(arrS[i])
                  break
                }
              }
            }
            this.optionsandroidPage = arrF
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取所有页面权限
    async geth5Pages() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        // this.data = []
        console.log(data)
        await http.post('/wapi/v1/geth5Pages', data).then((res) => {
          loading.close()
          if (res.success) {
            console.log(res, 11)
            this.options6 = res.data
            let array = res.data
            let arrF = []
            let arrS = []
            array.forEach((item, index) => {
              item.children = []
              if (!item.parent_menu) {
                arrF.push(item)
              } else {
                arrS.push(item)
              }
            })
            for (let i = 0; i < arrS.length; i++) {
              for (let j = 0; j < arrF.length; j++) {
                if (arrS[i].parent_menu === arrF[j].menu_id) {
                  arrF[j].children.push(arrS[i])
                  break
                }
              }
            }
            this.optionsh5Page = arrF
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取所有页面权限
    async getiosPages() {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
        }
        // this.data = []
        console.log(data)
        await http.post('/wapi/v1/getiosPages', data).then((res) => {
          loading.close()
          if (res.success) {
            console.log(res, 11)
            this.options5 = res.data
            let array = res.data
            let arrF = []
            let arrS = []
            array.forEach((item, index) => {
              item.children = []
              if (!item.parent_menu) {
                arrF.push(item)
              } else {
                arrS.push(item)
              }
            })
            for (let i = 0; i < arrS.length; i++) {
              for (let j = 0; j < arrF.length; j++) {
                if (arrS[i].parent_menu === arrF[j].menu_id) {
                  arrF[j].children.push(arrS[i])
                  break
                }
              }
            }
            this.optionsiosPage = arrF
            console.log(this.optionsiosPage, 'ios')
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //添加页面权限
    addPages: async function() {
      let array = this.$refs.treePage.getCheckedNodes().concat(this.$refs.treePage.getHalfCheckedNodes())
      // this.options3.forEach(item=>{
      //     if (item.check === checkSuccess){
      //         this.checkListPage.push(item.menu_id)
      //     }else {
      //         this.checkListPageDanger.push(item.menu_id)
      //     }
      // })
      let arrayCheckSuccess = []
      let arrayEveryPage = []

      array.forEach((item, index) => {
        arrayCheckSuccess.push(item.menu_id)
      })
      this.options3.forEach((item, index) => {
        arrayEveryPage.push(item.menu_id)
      })

      let arrayCheckNo = getArrDifference(arrayCheckSuccess, arrayEveryPage)
      function getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v)
        })
      }

      this.checkListPageDanger = arrayCheckNo
      this.checkListPage = arrayCheckSuccess
      this.deletePages()
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: this.checkListPage,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addPages', data).then((res) => {
          debugger
          this.dialogFormVisible6 = false
          loading.close()
          if (res.success) {
            this.menu_id = ''
            this.checkListPage = []
            this.getPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //添加android页面权限
    addandroidPages: async function() {
      let array = this.$refs.androidtreePage.getCheckedNodes().concat(this.$refs.androidtreePage.getHalfCheckedNodes())
      let arrayCheckSuccess = []
      let arrayEveryPage = []

      array.forEach((item, index) => {
        arrayCheckSuccess.push(item.menu_id)
      })
      this.options4.forEach((item, index) => {
        arrayEveryPage.push(item.menu_id)
      })

      let arrayCheckNo = getArrDifference(arrayCheckSuccess, arrayEveryPage)
      function getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v)
        })
      }

      this.checkListPageDanger = arrayCheckNo
      this.checkListPage = arrayCheckSuccess
      this.deleteandroidPages()
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: this.checkListPage,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addandroidaddPages', data).then((res) => {
          this.dialogFormVisible7 = false
          loading.close()
          if (res.success) {
            this.menu_id = ''
            this.checkListPage = []
            this.getandroidPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    handleCheckAllChange(type) {
      if (type == 'ios') {
        if (this.checkAll) {
          this.$refs.iostreePage.setCheckedNodes(this.optionsiosPage)
        } else {
          this.$refs.iostreePage.setCheckedKeys([])
        }
      } else if (type == 'android') {
        if (this.checkAll) {
          this.$refs.androidtreePage.setCheckedNodes(this.optionsandroidPage)
        } else {
          this.$refs.androidtreePage.setCheckedKeys([])
        }
      } else if (type == 'h5') {
        if (this.checkAll) {
          this.$refs.h5treePage.setCheckedNodes(this.optionsh5Page)
        } else {
          this.$refs.h5treePage.setCheckedKeys([])
        }
      }
    },

    //添加h5页面权限
    addh5Pages: async function() {
      let array = this.$refs.h5treePage.getCheckedNodes().concat(this.$refs.h5treePage.getHalfCheckedNodes())
      let arrayCheckSuccess = []
      let arrayEveryPage = []

      array.forEach((item, index) => {
        arrayCheckSuccess.push(item.menu_id)
      })
      this.options6.forEach((item, index) => {
        arrayEveryPage.push(item.menu_id)
      })

      let arrayCheckNo = getArrDifference(arrayCheckSuccess, arrayEveryPage)
      function getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v)
        })
      }

      this.checkListPageDanger = arrayCheckNo
      this.checkListPage = arrayCheckSuccess
      this.deleteh5Pages()
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: this.checkListPage,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addh5addPages', data).then((res) => {
          this.dialogFormVisible9 = false
          loading.close()
          if (res.success) {
            this.menu_id = ''
            this.checkListPage = []
            this.geth5PagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //添加ios页面权限
    addiosPages: async function() {
      let array = this.$refs.iostreePage.getCheckedNodes().concat(this.$refs.iostreePage.getHalfCheckedNodes())
      let arrayCheckSuccess = []
      let arrayEveryPage = []

      array.forEach((item, index) => {
        arrayCheckSuccess.push(item.menu_id)
      })
      this.options5.forEach((item, index) => {
        arrayEveryPage.push(item.menu_id)
      })

      let arrayCheckNo = getArrDifference(arrayCheckSuccess, arrayEveryPage)
      function getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v)
        })
      }

      this.checkListPageDanger = arrayCheckNo
      this.checkListPage = arrayCheckSuccess
      this.deleteiosPages()
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: this.checkListPage,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/addiosaddPages', data).then((res) => {
          this.dialogFormVisible8 = false
          loading.close()
          if (res.success) {
            this.menu_id = ''
            this.checkListPage = []
            this.getiosPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //获取安卓页面权限列表
    async getandroidPagesByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getaddandroidPagesByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.androidpages = []
            this.androidpages = res.data
            this.androidpages.sort(function(a, b) {
              return a.sort - b.sort
            })
            this.androidpagesArr = []
            res.data.forEach((item) => {
              this.androidpagesArr.push(item.menu_id)
            })

            let array = []
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < res.data.length; j++) {
                if (res.data[j].parent_menu === res.data[i].menu_id) {
                  res.data[i].check = true
                }
              }
            }
            for (let k = 0; k < res.data.length; k++) {
              if (res.data[k].check != true) {
                let obj = res.data[k]
                array.push(obj)
              }
            }
            this.androidexpandedKeys = array
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取H5页面权限列表
    async geth5PagesByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getaddh5PagesByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.h5pages = []
            this.h5pages = res.data
            this.h5pages.sort(function(a, b) {
              return a.sort - b.sort
            })
            this.h5pagesArr = []
            res.data.forEach((item) => {
              this.h5pagesArr.push(item.menu_id)
            })

            let array = []
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < res.data.length; j++) {
                if (res.data[j].parent_menu === res.data[i].menu_id) {
                  res.data[i].check = true
                }
              }
            }
            for (let k = 0; k < res.data.length; k++) {
              if (res.data[k].check != true) {
                let obj = res.data[k]
                array.push(obj)
              }
            }
            this.h5expandedKeys = array
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //获取ios页面权限列表
    async getiosPagesByRoleId(myData) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          role_id: myData.role_id,
        }

        await http.post('/wapi/v1/getaddiosPagesByRoleId', data).then((res) => {
          loading.close()
          if (res.success) {
            this.iospages = []
            this.iospages = res.data
            this.iospages.sort(function(a, b) {
              return a.sort - b.sort
            })
            this.iospagesArr = []
            res.data.forEach((item) => {
              this.iospagesArr.push(item.menu_id)
            })

            let array = []
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < res.data.length; j++) {
                if (res.data[j].parent_menu === res.data[i].menu_id) {
                  res.data[i].check = true
                }
              }
            }
            for (let k = 0; k < res.data.length; k++) {
              if (res.data[k].check != true) {
                let obj = res.data[k]
                array.push(obj)
              }
            }
            this.iosexpandedKeys = array
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    async deleteiosPages(key) {
      console.log(key)

      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: key != undefined ? this.iospages[key].menu_id : this.checkListPageDanger,
          role_id: this.upForm.role_id,
          client_id: 'com.saasyun.h5-ios',
        }

        await http.post('/wapi/v1/deletePages', data).then((res) => {
          loading.close()
          if (res.success) {
            this.pages.splice(key, 1)
            this.menu_id = ''
            this.checkListPageDanger = []
            this.getiosPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    async deleteandroidPages(key) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: key != undefined ? this.androidpages[key].menu_id : this.checkListPageDanger,
          role_id: this.upForm.role_id,
          client_id: 'com.saasyun.h5-android',
        }

        await http.post('/wapi/v1/deletePages', data).then((res) => {
          loading.close()
          if (res.success) {
            this.pages.splice(key, 1)
            this.menu_id = ''
            this.checkListPageDanger = []
            this.getandroidPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    async deleteh5Pages(key) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: key != undefined ? this.h5pages[key].menu_id : this.checkListPageDanger,
          role_id: this.upForm.role_id,
          client_id: 'com.saasyun.h5',
        }

        await http.post('/wapi/v1/deletePages', data).then((res) => {
          loading.close()
          if (res.success) {
            this.pages.splice(key, 1)
            this.menu_id = ''
            this.checkListPageDanger = []
            this.geth5PagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },
    //删除报表权限
    async deleteReport(key) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          report_id: key != undefined ? this.statement[key].report_id : this.checkListReportDanger,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/deleteReport', data).then((res) => {
          loading.close()
          if (res.success) {
            this.statement.splice(key, 1)
            this.action_id = ''
            this.checkListReportDanger = []
            this.getReportsByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //删除页面权限
    async deletePages(key) {
      console.log(key)

      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          menu_id: key != undefined ? this.pages[key].menu_id : this.checkListPageDanger,
          role_id: this.upForm.role_id,
        }

        await http.post('/wapi/v1/deletePages', data).then((res) => {
          loading.close()
          if (res.success) {
            this.pages.splice(key, 1)
            this.menu_id = ''
            this.checkListPageDanger = []
            this.getPagesByRoleId(data)
          }
        })
      } catch (err) {
        loading.close()
        console.log(`error:${err}`)
      }
    },

    //新建顶级文件夹
    append2(value) {
      const newChild = { id: id++, label: value, children: [] }
      this.data2.push(newChild)
    },
    //新建角色弹框
    open3() {
      ;(this.form = {
        role_name: '',
        role_code: '',
        comments: '',
      }),
        (this.dialogFormVisible = true)
    },
    //编辑角色弹框
    open4() {
      if (this.updataActive) {
        this.dialogFormVisible2 = true
      }
    },
    //添加用户弹框
    addListOpen() {
      this.dialogFormVisible3 = true
      this.messageDis = false
    },
    //添加功能权限弹框
    limitsOpen() {
      this.dialogFormVisible4 = true
      this.options.forEach((item) => {
        if (this.actionsArr.indexOf(item.action_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },
    //添加报表权限弹框
    statementOpen() {
      this.dialogFormVisible5 = true
      this.options2.forEach((item) => {
        if (this.reportsArr.indexOf(item.report_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },
    //添加页面权限弹框
    pagesOpen() {
      this.dialogFormVisible6 = true
      this.$nextTick(() => {
        this.$refs.treePage.setCheckedNodes(this.expandedKeys)
      })
      this.options3.forEach((item) => {
        if (this.pagesArr.indexOf(item.menu_id) !== -1) {
          item.check = checkSuccess
        } else {
          item.check = check
        }
      })
    },

    //部门员工
    async getUserOuList(ou_id) {
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        let user = this.$store.getters.getUser
        let data = {
          tenant_id: user.tenant_id,
          ou_id: ou_id,
          pageIndex: this.page.current,
          pageSize: this.page.size,
          users: this.user,
        }

        await http.post('/wapi/v1/getUserOuList', data).then((res) => {
          loading.close()
          if (res.success) {
            this.page.total = parseInt(res.count)
            this.tableData = []
            // console.log(this.tableData,23)
            res.data.forEach((item) => {
              let sex = ''
              if (item.gender === 'M') {
                sex = '男'
              } else if (item.gender === 'F') {
                sex = '女'
              } else {
                sex = ''
              }
              let status = ''
              if (item.status === 'ACTIVE') {
                status = '在职'
              } else {
                status = '离职'
              }
              let zhuGuan = ''
              if (item.role === 'STAFF') {
                zhuGuan = '否'
              } else {
                zhuGuan = '是'
              }

              let obj = {
                rowIndex: parseInt(item.rowindex),
                user_id: item.user_id,
                name: item.last_name,
                sex: sex,
                birthday: item.birthday,
                duty: item.title,
                phone: item.phone,
                status: status,
                role: item.roles,
                zhuGuan: zhuGuan,
              }
              this.tableData.push(obj)
            })
          }
        })
      } catch (err) {
        loading.close()
        Message.error('获取失败')
      }
    },
    //点击用户
    rowClick(row) {
      this.userInfo = row
      this.messageDis = true

      this.user_id = row.user_id
      this.radio = parseInt(row.rowIndex)
    },
    //点击部门
    handleNodeClick2(data, node) {
      this.radio = 0
      this.messageDis = false
      this.ou_id = data.ou_id
      this.getUserOuList(data.ou_id)
    },
    // 改变页码信息
    changePageClick(page, size) {
      if (page) {
        this.page.current = page
      }
      if (size) {
        this.page.size = size
      }
      this.getUserOuList(this.ou_id)
    },

    handleNodeClick(data, node, ele) {
      console.log(data)
      if (data.role_name === '系统内置' || data.role_name === '自定义') {
        this.addUserDis = true
        return
      } else {
        this.addUserDis = false

        this.getUsersByRoleId(data)
        this.getActionsByRoleId(data)
        this.getReportsByRoleId(data)
        this.getPagesByRoleId(data)
        this.getandroidPagesByRoleId(data)
        this.getiosPagesByRoleId(data)
        this.geth5PagesByRoleId(data)
        this.getOU()
        this.tableData = []
        this.report_id = ''
        this.action_id = ''
        this.myactive2 = false
        this.myactive1 = true
        this.treeKey = node.key
        this.schTitle1 = data.role_name
        let obj = {
          role_name: data.role_name,
          role_code: data.role_code,
          comments: data.comments,
          role_id: data.role_id,
        }
        this.upForm = obj
        this.clickData.tenant_id = data.tenant_id
        this.clickData.role_id = data.role_id
        //禁用状态
        if (data.onlyread === 'T') {
          this.updataActive = false
        } else {
          this.updataActive = true
        }
      }
    },
    cancelDialog() {
      this.dialogFormVisible3 = false
      this.userInfo = {}
      this.tableData = []
      ;(this.page = {
        current: 1,
        size: 5,
        total: 0,
      }),
        this.getOU()
    },
    changeRadio(item, index) {
      // this.$nextTick(()=> {
      //     if (this.options3[index].check == check){
      //         this.options3[index].check = checkSuccess
      //         console.log(item,'1')
      //     } else {
      //         this.options3[index].check = check
      //         console.log(item,'2')
      //     }
      // })
      if (item.check == check) {
        Vue.set(this.options3[index], 'check', checkSuccess)
      } else {
        Vue.set(this.options3[index], 'check', check)
      }
      this.$forceUpdate()
    },
    changeRadioActions(item, index) {
      if (item.check == check) {
        Vue.set(this.options[index], 'check', checkSuccess)
      } else {
        Vue.set(this.options[index], 'check', check)
      }
      this.$forceUpdate()
    },
    changeRadioReport(item, index) {
      if (item.check == check) {
        Vue.set(this.options2[index], 'check', checkSuccess)
      } else {
        Vue.set(this.options2[index], 'check', check)
      }
      this.$forceUpdate()
    },
  },
  updated() {
    // console.log(this.options3,3)
    if (this.schTitle1 != '') {
      this.addUserDis = false
    }
  },
}
</script>

<style>
#limits {
  overflow: auto;
}

/*限制文字长度*/
#limits #el-scollbar .el-tree-node__content span {
  max-width: 240px;
  margin-left: 10px;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  color: #bbbbbb;
  white-space: nowrap;
}

#limits .filter-tree .el-tree-node__expand-icon {
  display: none;
}

#limits .el-tree-node__content {
  /*display: flex;*/
  /*justify-content: space-between;*/
  height: 40px;
}

#limits .el-tree-node.is-expanded.is-focusable > .el-tree-node__content {
  /*background: #f6f7fa;*/
}

#limits .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content:before {
  content: '';
  display: inline-block;
  background: url('../../../assets/images/role.png') no-repeat;
  background-size: 16px;
  width: 16px;
  height: 16px;
  margin: 20px;
}

#pageDialog .el-checkbox {
  margin-left: 40px;
}

#pageDialog .el-checkbox:before {
  content: '';
  display: inline-block;
  position: absolute;
  background: url('../../../assets/images/page.png') no-repeat;
  background-size: 16px;
  width: 16px;
  height: 18px;
  top: 50%;
  margin-top: -9px;
  left: -30px;
}

#limits #el-scollbar .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content span {
  margin-left: 0;
  font-size: 16px;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #606266;
  line-height: 38px;
}

/*输入框背景*/
#limits .sWei .el-input__inner {
  background: #eee;
}

#limits .StoCen {
  background: white;
  height: auto;
  padding: 0 15px;
}

/*.el-main{
      padding: 0;
    }*/
#limits {
  display: flex;
  justify-content: center;
  height: 100%;
}

#limits .StoW .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
}

#limits .el-row {
  margin-bottom: 12px;
  height: 30px;
}

#limits .xux {
  border-bottom: 2px dashed #eee;
  height: 10px;
}

#limits .butC {
  padding: 8px 10px;
  margin-top: 26px;
}

#limits .tally {
  border: 2px solid rgb(29, 170, 252);
  height: 100%;
  width: 110px;
  margin: 0 10px;
  padding: 0 5px;
  color: rgb(29, 170, 252);
}

#limits .tally:nth-of-type(2) {
  border-color: rgb(30, 255, 79);
  color: rgb(30, 255, 79);
}

#limits .tally:nth-of-type(3) {
  border-color: rgb(255, 203, 30);
  color: rgb(255, 203, 30);
}

#limits .tally:nth-of-type(4) {
  border-color: rgb(255, 30, 244);
  color: rgb(255, 30, 244);
}

#limits .tallyBox {
  height: 60px;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}

#limits .tally .el-row {
  margin: 0;
  font-size: 12px;
  height: 25px;
}

#limits .tally .el-row:nth-of-type(2) {
  text-align: center;
  font-size: 20px;
}

#limits .cell {
  text-align: left;
}

#limits .el-dialog__header {
  border-bottom: 2px dashed #dcdfe6;
  padding: 20px 0 20px 0;
  margin: 20px 20px 10px;
}

#limits .el-dialog__close {
  display: none;
}

#limits .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}

#limits .el-form-item__label {
  color: black;
  text-align: left;
  font-weight: bold;
  padding-left: 20px;
}

#limits .el-input__inner::-webkit-input-placeholder {
  text-align: center;
}

.el-input__inner {
  /*font-family: 'iconfont';*/
}

.dialog-footer {
  margin-top: 10px;
}

#el-button span {
  font-weight: bold;
}

#limits .cell {
  color: #585757;
}

#limits .message {
}

#limits .message .el-row {
  padding-top: 30px;
}

#limits .el-table {
}

#limits .ul::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/components/limits.vue